import React from 'react';
import { Card } from './ui/card';
import { Button } from './ui/button';
import { Calendar, ArrowRight } from 'lucide-react';
import { events } from '../data/mock';

export const Events = () => {
  return (
    <section id="eventi" className="relative py-24 md:py-32 bg-slate-900 overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle, #f59e0b 1px, transparent 1px)',
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-20">
          <div className="inline-flex flex-col items-center gap-4 mb-6">
            <div className="h-px w-16 bg-amber-400"></div>
            <h2 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white uppercase tracking-tight" 
                style={{ fontFamily: "'Staatliches', cursive" }}>
              News <span className="text-amber-400">&</span> Eventi
            </h2>
            <div className="h-px w-16 bg-amber-400"></div>
          </div>
          <p className="text-xl md:text-2xl text-gray-400 max-w-3xl mx-auto font-light">
            Feste, musica dal vivo, jam session e tanto altro!
          </p>
        </div>

        {/* Events Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {events.map((event) => (
            <Card
              key={event.id}
              className="group bg-slate-800 border-slate-700 overflow-hidden hover:border-amber-400 transition-all duration-500 hover:shadow-2xl hover:shadow-amber-500/20"
            >
              {/* Event Image */}
              <div className="relative h-56 overflow-hidden">
                <img
                  src={event.image}
                  alt={event.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/60 to-transparent"></div>
                
                {/* Date Badge */}
                <div className="absolute top-4 right-4 bg-amber-500 text-black px-3 py-2 rounded-lg shadow-lg">
                  <Calendar className="w-4 h-4 mb-1" />
                  <p className="text-xs font-bold whitespace-nowrap" style={{ fontFamily: "'Staatliches', cursive" }}>
                    {event.date}
                  </p>
                </div>
              </div>

              {/* Event Content */}
              <div className="p-6">
                <h3 className="text-xl font-bold text-white mb-3 group-hover:text-amber-400 transition-colors duration-300 uppercase tracking-wide"
                    style={{ fontFamily: "'Staatliches', cursive" }}>
                  {event.title}
                </h3>
                <p className="text-gray-400 text-sm leading-relaxed mb-4">
                  {event.description}
                </p>
                <Button
                  variant="ghost"
                  size="sm"
                  className="text-amber-400 hover:text-amber-300 hover:bg-amber-400/10 p-0 h-auto font-semibold group/btn"
                >
                  Scopri di più
                  <ArrowRight className="w-4 h-4 ml-2 group-hover/btn:translate-x-1 transition-transform" />
                </Button>
              </div>
            </Card>
          ))}
        </div>

        {/* Info Section */}
        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          <div className="text-center p-8 bg-slate-800/50 backdrop-blur-sm border border-slate-700 rounded-xl hover:border-amber-400 transition-all duration-300">
            <div className="text-4xl mb-4">🎵</div>
            <h3 className="text-white font-semibold mb-2 text-lg" style={{ fontFamily: "'Staatliches', cursive", letterSpacing: '0.05em' }}>
              MUSICA DAL VIVO
            </h3>
            <p className="text-gray-400 text-sm">
              L'inverno il mercoledì sera potete cenare in compagnia delle nostre serate di musica live
            </p>
          </div>

          <div className="text-center p-8 bg-slate-800/50 backdrop-blur-sm border border-slate-700 rounded-xl hover:border-amber-400 transition-all duration-300">
            <div className="text-4xl mb-4">🌄</div>
            <h3 className="text-white font-semibold mb-2 text-lg" style={{ fontFamily: "'Staatliches', cursive", letterSpacing: '0.05em' }}>
              ALL'APERTO
            </h3>
            <p className="text-gray-400 text-sm">
              L'estate vi facciamo mangiare all'aperto nel clima fresco della nostra collina
            </p>
          </div>

          <div className="text-center p-8 bg-slate-800/50 backdrop-blur-sm border border-slate-700 rounded-xl hover:border-amber-400 transition-all duration-300">
            <div className="text-4xl mb-4">📞</div>
            <h3 className="text-white font-semibold mb-2 text-lg" style={{ fontFamily: "'Staatliches', cursive", letterSpacing: '0.05em' }}>
              TAKE AWAY
            </h3>
            <p className="text-gray-400 text-sm">
              Potete ordinare il vostro take away telefonandoci dalle 18 in poi
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
